module.exports = __webpack_public_path__ + "img/friend_header_bg.2818146f.png";